import { Stack } from '@mui/material';
import styled from 'styled-components';

export const SelectedItemsContainer = styled(Stack)`
  && {
    height: 100%;
    min-height: 3.25rem;
    overflow: auto;
  }
`;
